<template>
  <b-container>
    <b-row>
      <b-col sm="12" md="6" lg="6">
        <h1>{{ $t("tracking.cargoExpense.edit") }}</h1>
        <success-fade-alert ref="alert" :msg="alert.success" />
        <fade-alert-danger ref="danger" :msg="alert.error" />

        <b-row class="mb-3 ml-0">
          <router-link :to="getUrlBackToList">
            <b-button size="sm">{{ $t("geral.backtolist") }}</b-button>
          </router-link>
        </b-row>
        <div>
          <!-- {{model}} -->
          <!-- {{model.permissions}} -->
          <div v-if="model.permissions != 0">
            <div v-if="model.permissions == 1">
              <cargo-expense-crud-data
                ref="crud"
                :model="model"
                :modelstate="modelstate"
                :readonly="canEdit"
                :cargoExpenseTypeId="model.cargoExpenseTypeId"
                :permissions="model.permissions"
                class="mb-4"
              >
              </cargo-expense-crud-data>
              <custom-value
                ref="customValue"
                :items.sync="model.customValues"
                :occurrenceId="model.cargoExpenseOccurrenceId"
                :id="id"
                :readonly="getPermission"
                :modelstate="modelstate"
                class="customValue"
              >
              </custom-value>
              <b-button class="button" @click="save" :disabled="canSubmit">
                {{ $t("geral.save") }}
              </b-button>
            </div>

            <div v-else-if="model.permissions == 2">
              <cargo-expense-crud-data
                ref="crud"
                :model="model"
                :modelstate="modelstate"
                :readonly="!getPermission"
                :cargoExpenseTypeId="model.cargoExpenseTypeId"
                :permissions="model.permissions"
                class="mb-4"
              >
              </cargo-expense-crud-data>
              <custom-value
                ref="customValue"
                :items.sync="model.customValues"
                :occurrenceId="model.cargoExpenseOccurrenceId"
                :id="id"
                :readonly="getPermission"
                :modelstate="modelstate"
                class="customValue"
              >
              </custom-value>
              <b-button class="button" @click="save" :disabled="!canSubmit">
                {{ $t("geral.save") }}
              </b-button>
            </div>
          </div>
        </div>
      </b-col>
    </b-row>
    <div class="mt-5" v-if="model.permissions != 0">
      <cargo-expense-story
        ref="cargoExpenseStory"
        :cargo-expense-id="getCargoExpenseId"
      >
      </cargo-expense-story>
    </div>
    <!-- <div>{{ canEdit }}</div> -->
    <!-- <div>getCargoExpenseId: {{getCargoExpenseId}}</div> -->
    <!-- {{ model.cargoExpenseOccurrenceId }} -->
    <!-- <div>{{ occurrenceId }}</div> -->
    <!-- <div>{{ modelstate }}</div> -->
    <!-- <div>{{ model }}</div> -->
    <!-- <div>{{profile}}</div> -->
  </b-container>
</template>

<script>
import FadeAlertDanger from "@/components/FadeAlertDanger.vue";
import SuccessFadeAlert from "@/components/SuccessFadeAlert.vue";
import CargoExpenseCrudData from "@/components_rms/trackingShippingCompany/cargoExpense/CargoExpenseCrudData.vue";
import CargoExpenseStory from "@/components_rms/trackingShippingCompany/cargoExpense/CargoExpenseStory.vue";
import CustomValue from "@/components_rms/trackingShippingCompany/cargoExpense/CustomValue.vue";

export default {
  name: "CargoExpenseEdit",
  components: {
    FadeAlertDanger,
    SuccessFadeAlert,
    CargoExpenseCrudData,
    CargoExpenseStory,
    // CustomFields,
    CustomValue,
  },
  props: {
    id: String,
    companyId: String,
  },
  data() {
    return {
      alert: {
        error: "",
        success: "Registro alterado com sucesso",
      },
      submitted: false,
      modelstate: {},
      model: {
        adicionalInformation: "",
        branchName: "",
        cargoExpenseId: 0,
        cargoId: 0,
        cargoExpenseTypeId: 0,
        cargoExpenseTypeDescription: "",
        clientName: "",
        driverName: "",
        value: 0.0,
        responsability: 1,
        priority: 1,
        permissions: 0,
        customValues: [],
      },
      customFields: [],
      editField: false,
      occurrenceId: 0,
      cargoExpenseTypeId: 0,
      values: [],
      profile: [],
    };
  },
  mounted() {
    this.loadData();
  },
  computed: {
    getPermission() {
      if (this.model.permissions == 2) return true;
      return false;
    },
    canEdit() {
      if (!this.model) {
        return false;
      }
      if (!this.model.cargoActive) {
        return true;
      }
      if (this.model.status == 13) {
        return false;
      }

      return true;
    },
    canSubmit() {
      if (this.submitted) {
        return true;
      }
      if (!this.canEdit) {
        return true;
      }
      return false;
    },
    getCargoExpenseId() {
      if (!this.id) return 0;
      if (this.id.trim() == "") return 0;
      return parseInt(this.id);
    },
    getUrlBackToList() {
      if (this.model) {
        return `../../cargoExpense/list/${this.model.cargoId}`;
      }
      return `../../cargoExpense/list`;
    },
    getUrlCargoList() {
      if (this.companyId) {
        return `/v1/cargoExpense/get/${this.id}/${this.companyId}`;
      }
      return `/v1/cargoExpense/get/${this.id}`;
    },
  },
  methods: {
    async loadData() {
      this.$api
        .get(this.getUrlCargoList)
        .then(async (response) => {
          let model = response.data;
          // console.log("modelLoadData");
          // console.log(model);
          if (model.attachments.length > 0) {
            model.attachments.forEach(async (attachment) => {
              console.log(attachment.content);
              const image = await this.loadImg(
                attachment.cargoExpenseAttachmentId
              );
              console.log(image);
              if (image) attachment.content = image;
              else attachment.content = "";
            });
          }
          this.model = model;
          // this.occurrenceId = model.cargoExpenseOccurrenceId;
          this.getProfilePermition();
          // this.getCustomValue();
        })
        .catch((error) => {
          console.log(error);
          console.log(error.response);
          if (error.response.status == 401) {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          } else {
            if (error.response) {
              if (error.response.status == 400) {
                this.modelstate = error.response.data.errors;
              }
            }
            this.alert.error = error.message;
            this.$refs.danger.show();
          }
        });
    },
    async loadImg(attachmentId) {
      if (attachmentId == 0) return;
      let image = "";
      await this.$api
        .request({
          url: `${this.$store.state.urlTracking}/v1/cargoExpense/attachmentImage/${attachmentId}`,
          method: "GET",
          responseType: "arraybuffer", //important
        })
        .then((response) => {
          image = window.URL.createObjectURL(
            new Blob([response.data], {
              type: response.headers["content-type"],
            })
          );
        })
        .catch((error) => {
          console.log(error);
          console.log(error.response.data.errors);
          if (error.response.status == 400) {
            console.log(error.response.data.errors);
          }
        });
      return image;
    },
    save() {
      try {
        this.submitted = true;
        let crudData = this.$refs.crud.getDataAsOjbect();
        // console.log(crudData)
        this.$api
          .post(`/v1/cargoExpense/edit/${this.model.cargoExpenseId}`, crudData)
          // .post(
          //   "/v1/cargoExpense/edit/" + this.model.cargoExpenseId.toString(),
          //   formData,
          //   {
          //     headers: {
          //       "Content-Type": "multipart/form-data",
          //     },
          //   }
          // )
          .then((response) => {
            console.log("salvamento");
            console.log(response);
            // if (response.data.success == false) {
            //   this.alert.error = response.data.title;
            //   this.$refs.danger.show();
            // } else {
            this.loadData();
            this.$forceUpdate();
            this.$refs.cargoExpenseStory.refresh();
            this.$refs.alert.show();
            this.modelstate = {};
            this.submitted = false;
            // }
          })
          .catch((error) => {
            this.submitted = false;
            this.modelstate = {};
            console.log(error);
            console.log(error.reposnse);
            if (error.response) {
              if (error.response.status == 400) {
                this.modelstate = error.response.data.errors;
                this.alert.error = error.message;
                this.$refs.danger.show();
              } else if (error.response.status == 404) {
                console.log(error.response.data.message);
                this.alert.error = error.response.data.message;
                this.$refs.danger.show();
                // console.log(error.response.data.errors);
              } else if (error.response.status == 500) {
                this.alert.error = error.response.data;
                this.$refs.danger.show();
              } else {
                this.alert.error = error.message;
                this.$refs.danger.show();
              }
            } else {
              this.alert.error = error.message;
              this.$refs.danger.show();
            }
          });
      } catch (e) {
        console.log(e);
        this.submitted = false;
        this.modelstate = {};
        this.alert.error = e.message;
        this.$refs.danger.show();
      }
    },
    getProfilePermition() {
      this.$api
        .get(`/v1/cargoExpense/occurrence/getProfile`)
        .then((response) => {
          let model = response.data;
          this.profile = model;
        });
    },
  },
  watch: {
    stateId() {
      this.loadData();
    },
  },
};
</script>

